import { useNavigate } from "react-router-dom";

function ClientNavigation() {
  const clientName = localStorage.getItem("selectedClientName") || "Cliente";
  const navigate = useNavigate();

  return (
    <div className="client-navigation">
      <div className="navigation-path">
        <div className="navigation-item">
          <div className="navigation-text" onClick={() => navigate("/team")}>Clientes</div>
          <div className="navigation-arrow">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="arrow-icon"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.72725 13.1477C6.50758 12.9281 6.50758 12.5719 6.72725 12.3523L10.0795 9L6.72725 5.64775C6.50758 5.42808 6.50758 5.07192 6.72725 4.85225C6.94692 4.63258 7.30308 4.63258 7.52275 4.85225L11.2727 8.60225C11.3782 8.70774 11.4375 8.85082 11.4375 9C11.4375 9.14918 11.3782 9.29226 11.2727 9.39775L7.52275 13.1477C7.30308 13.3674 6.94692 13.3674 6.72725 13.1477Z"
                fill="#364152"
              />
            </svg>
          </div>
        </div>
        <div className="navigation-current" onClick={() => navigate("/campaign-detail")}>{clientName}</div>
      </div>
    </div>
  );
}

export default ClientNavigation;
